export enum AgsLayers {
    JACKPOTS = "Jackpots",
    LOGOS = "Logos",
    RAYS = "Rays",
    FIREWORK_SPARK = "FireworkSpark",
    FIREWORKS = "Fireworks",
    LUCK = "LuckHasArrived",
    FIREWORK_EXPLOSION = "FireworkExplosion",
    BIGWIN_TEXT = "BigWinText",
    BIG_WIN_EMITTER = "BigWinEmitter"
}
